import { AxiosInstance } from 'axios'

import { DashboardMainCompany } from '@modules/dashboard/types/DashboardCompanies/dashboard'
import { GetDashboardCompaniesRequest } from '@modules/dashboard/types/DashboardCompanies/requests'

export class DashboardCompaniesService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async get(params: GetDashboardCompaniesRequest): Promise<DashboardMainCompany> {
    const response = await this.instance.get('/companies/dashboard', { params })

    return response.data
  }
}

export const dashboardCompaniesService = (instance: AxiosInstance) => new DashboardCompaniesService(instance)
